import ResultPage from '@/components/Result/index'
import { assetUrl } from '@/utils/asset-url'

const ShareDataSuccessPage = () => {
	const breadcrumbItem = [
		{
			label: '',
			link: `/`,
		},
		{
			label: 'Received Data',
			link: `/received-data`
		},
		{
			label: 'Request Data',
			link : `/received-data/request`,
		},
		{
			label: 'Success',
			link: `/received-data/request/success`
		}
	]

	return ResultPage({
		layoutHeaderTxt: "dataFileRequested",
		layoutSubHeaderTxt: "dataFileRequestedMessage",
		layoutContentImgPath: assetUrl("/img/success.png"),
		defaultTitle: "requestData",
		nextLocation: '/received-data',
		breadcrumbs: breadcrumbItem,
		backBtnTxt: "backToReceivedData",
	});
}
export default ShareDataSuccessPage
